<template>
  <div>
    <hb-data-table-header>
      <template v-slot:header> Property History </template>
      <template v-slot:description>
        All past end of months ran at the property level.
      </template>
    </hb-data-table-header>
    <HbPropertySelector
      id="property"
      :items="facilityList"
      item-text="name"
      item-value="id"
      v-validate="'required'"
      v-model.lazy="property_id"
      data-vv-scope="coseOfDay"
      data-vv-name="property"
      data-vv-as="Property"
      :error="errors.has('property')"
    />
    <v-card
      class="mt-0 mb-3"
      elevation="0"
    >
      <hb-empty-state
        v-if="!property_id"
        message="Please select a Property to continue."
        :showBtn="false"
      >
      </hb-empty-state>
      <div v-else>
        <hb-data-table
          :headers="headers"
          :items="historyData"
        >
          <template v-slot:item.prop_number="{ item }">
            {{ item.prop_number }}
          </template>
          <template v-slot:item.prop_name="{ item }">
            {{ item.prop_name }}
          </template>
          <template v-slot:item.period_start="{ item }">
            {{ item.period_start | changeDateTimeFormat("MMM, YYYY") }}
          </template>
          <template v-slot:item.closing_date="{ item }">
            <div>{{ item.closing_date | changeDateTimeFormat("MMMM D, YYYY") }}</div>
            <div>{{ item.closing_date | changeDateTimeFormat("h:mm A") }}</div>
          </template>
        </hb-data-table>
      </div>
    </v-card>
  </div>
</template>

<script type="text/babel">
import api from "../../assets/api.js";
import { mapGetters } from "vuex";

export default {
  name: "PropertyHistoryTable",
  data() {
    return {
      property_id: "",
      historyData: [],
      headers: [
        {
          text: "Property ID",
          value: "prop_number",
          sortable: false,
        },
        { text: "Property Name", value: "prop_name" },
        { text: "Month Closed", value: "period_start" },
        { text: "End Time", value: "closing_date" },
      ],
    };
  },
  components: {},
  created() {
    this.property_id = this.defaultProperty ? this.defaultProperty.id : null;
    this.fetchData();
  },
  computed: {
    ...mapGetters({
      facilityList: "propertiesStore/filtered",
      defaultProperty: "propertiesStore/defaultProperty",
    }),
  },
  methods: {
    async fetchData() {
      if (!this.property_id) {
        return false;
      }
      await api
        .get(
          this,
          api.END_OF_MONTH_PROPERTY_HISTORY +
            "/" +
            this.property_id +
            "/end-of-month-history"
        )
        .then((r) => {
          this.historyData = r?.history;
        });
    },
  },
  watch: {
    async property_id() {
      await this.fetchData();
    },
  },
};
</script>

<style scoped></style>
